import { Component, Prop, State, Watch, h } from '@stencil/core';

@Component({
    tag: 'list-component',
    shadow: false,
})
export class ListComponent {
    @Prop() searchCard: string;
    @Prop() list: any[];
  
    @State() filteredList: any[];
  
    @Watch('searchCard')
    @Watch('list')
    handleSearchChange() {
      if (this.list) {
        this.filteredList = this.list.filter(item => item.heading.toLowerCase().includes(this.searchCard.toLowerCase()));
      }
    }
  
    componentWillLoad() {
      this.handleSearchChange();
    }
  
    render() {
      return <div>
        {this.filteredList.map((item, index) => (
          <div key={index}>
            <ix-card variant="insight">
              <ix-card-content>
                <ix-icon name="capacity"></ix-icon>
                <ix-typography bold>{item.heading}</ix-typography>
                <ix-typography>{item.description}</ix-typography>
                <ix-typography format="h1">{item.number}</ix-typography>
              </ix-card-content>
            </ix-card>
          </div>
        ))}
      </div>;
    }
  }